import { render, staticRenderFns } from "./moon-referal.vue?vue&type=template&id=4f16abf2&scoped=true"
import script from "./moon-referal.vue?vue&type=script&lang=js"
export * from "./moon-referal.vue?vue&type=script&lang=js"
import style0 from "./moon-referal.vue?vue&type=style&index=0&id=4f16abf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16abf2",
  null
  
)

export default component.exports